import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet } from "react-router-dom";
import useApi from "../../hooks/useApi";
import Accordion from "react-bootstrap/Accordion";
import PolicyTypeRequirementCard from "./PolicyTypeRequirementCard";
import PolicyTypeClaimRequirementCard from "./PolicyTypeClaimRequirementCard";

const PolicyTypeView = () => {
  const [policyType, setPolicyType] = useState({});
  const { id } = useParams();

  const { api, abortSignal, auth } = useApi();
  useEffect(() => {
    const callApi = async () => {
      try {
        const response = await api.read(`/policies/policy-types/${id}`);
        // console.log(response);
        if (response.success) setPolicyType(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [id, auth]);

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/policy-types">Policy Types</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {policyType?.name || id}
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}

          <h1 className="page-title mb-0 mt-2">
            {policyType?.name || "Policy type detail"}
          </h1>

          <p className="lead">Detail view of Policy Type</p>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <div className="row">
            <div className="col-xxl-9 col-xl-8 col-lg-7 col-sm-12">
              {<Outlet />}
              <Accordion defaultActiveKey={["0"]} className="my-3">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Policy Requirements</Accordion.Header>
                  <Accordion.Body>
                    <PolicyTypeRequirementCard />
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Claims Requirements</Accordion.Header>
                  <Accordion.Body>
                    <PolicyTypeClaimRequirementCard />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-12">
              {/* <!-- User widget with background color --> */}
              <div className="card mb-3">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <a
                      href="#"
                      className="d-inline-block h5 btn-link text-truncate mb-2"
                    >
                      {policyType?.name}
                    </a>
                    <Link
                      to="edit"
                      className="btn btn-xs btn-hover btn-light text-decoration-none p-1"
                    >
                      <i className="demo-psi-pen-5 fs-5"></i>
                    </Link>
                  </div>
                  <div>
                    <small className="text-primary">Info</small>
                    <p className="text-break">{policyType?.info}</p>
                  </div>
                </div>
              </div>

              {/* <!-- END : User widget with background color --> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PolicyTypeView;
